(function () {
  'use strict';

    /* ---------- Universal cart-change detector ----------
     Intercepts every fetch to /cart/* so we catch cart mutations
     regardless of which custom event (if any) the theme dispatches.
    */
    var _origFetch = window.fetch;
    window.fetch = function () {
      var promise = _origFetch.apply(this, arguments);
      var url = arguments[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) || '';

      if (/\/cart\/(add|change|update|clear)/.test(urlStr)) {
        promise.then(function () {
          document.dispatchEvent(new CustomEvent('byob:cart-mutated'));
        });
      }
      return promise;
    };

  document.addEventListener('DOMContentLoaded', init);

  /* ---------- Discount tiers ----------
     Edit this array to change the thresholds/percentages.
     Must stay in ascending order of "qty".
  */
  var TIERS = [];

  function getCurrentTier(n) {
    var result = null;
    TIERS.forEach(function (t) { if (n >= t.qty) result = t; });
    return result;
  }

  function getNextTier(n) {
    for (var i = 0; i < TIERS.length; i++) {
      if (n < TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  function round2(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }

  function init() {
    var root = document.querySelector('[data-byob-root]');
    if (!root) return;

      var existingCartQty = parseInt(root.dataset.cartQty || '0', 10);
      if (isNaN(existingCartQty)) existingCartQty = 0;

      // Bundle discount preview only runs when the progress bar is ON in Theme settings.
      // When it's OFF, TIERS stays empty -> no discount %, no tier messages, full prices everywhere.
      var discountEnabled = root.dataset.discountEnabled === 'true';

      if (discountEnabled) {
        try {
          var parsedTiers = JSON.parse(root.dataset.tiers || '[]');
          parsedTiers.forEach(function (t) {
            if (t && t.qty && t.pct) {
              TIERS.push({ qty: Number(t.qty), pct: Number(t.pct) });
            }
          });
          TIERS.sort(function (a, b) { return a.qty - b.qty; });
        } catch (e) {
          console.error('BYOB: failed to parse tiers, using defaults', e);
          TIERS = [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 5, pct: 20 }];
        }
      }

    var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

    var emptyText = root.dataset.emptyText || 'No items yet — pick a colour and add your favourites.';

    var filter = 'all';
    var bundle = []; // { variantId, title, print, size, price, image }
    var qvCard = null;
    var qvSize = null;
    var lastSize = null;

    var overlay = $('[data-byob-overlay]');
    var qvImage = $('[data-byob-qv-image]');
    var qvName = $('[data-byob-qv-name]');
    var qvPrint = $('[data-byob-qv-print]');
    var qvPrice = $('[data-byob-qv-price]');
    var qvSizes = $('[data-byob-qv-sizes]');
    var qvAdd = $('[data-byob-qv-add]');
    var qvHint = $('[data-byob-qv-hint]');
    var qvClose = $('[data-byob-qv-close]');

    /* ---------- Colour filter ---------- */

    $$('[data-byob-color-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        filter = chip.dataset.color || 'all';

        $$('[data-byob-color-chip]').forEach(function (c) {
          var chipColor = c.dataset.color || 'all';
          c.classList.toggle('is-selected', chipColor === filter);
        });

        applyFilter();
      });
    });

    function applyFilter() {
      $$('[data-byob-card]').forEach(function (card) {
        var cardPrint = card.dataset.print || '';
        var show = filter === 'all' || cardPrint === filter;
        card.style.display = show ? '' : 'none';
      });
    }

    /* ---------- Quick view ---------- */
    $$('[data-byob-card]').forEach(function (card) {
      card.addEventListener('click', function () { openQuickView(card); });
    });

    function getVariants(card) {
      try { return JSON.parse(card.dataset.variants || '{}'); }
      catch (e) { return {}; }
    }

    function openQuickView(card) {
      qvCard = card;
      var variants = getVariants(card);
      var sizeKeys = Object.keys(variants);
      qvSize = (lastSize && variants[lastSize]) ? lastSize : null;

      qvImage.src = card.dataset.image || '';
      qvImage.alt = card.dataset.title || '';
      qvName.textContent = card.dataset.title || '';
      qvPrint.textContent = 'Print: ' + (card.dataset.print || '');
      qvPrice.textContent = card.dataset.priceFormatted || '';
      qvHint.textContent = qvSize
        ? ('Pre-set to your last size (' + qvSize + ') — change anytime.')
        : "We'll remember this size for your next add.";

      renderQvSizes(sizeKeys, variants);
      overlay.classList.add('is-open');
    }

    function renderQvSizes(sizeKeys, variants) {
      qvSizes.innerHTML = '';
      sizeKeys.forEach(function (size) {
        var v = variants[size];
        var btn = document.createElement('div');
        btn.className = 'byob-sz' + (qvSize === size ? ' is-selected' : '') + (!v.available ? ' is-unavailable' : '');
        btn.textContent = size;
        if (v.available) {
          btn.addEventListener('click', function () {
            qvSize = size;
            renderQvSizes(sizeKeys, variants);
          });
        }
        qvSizes.appendChild(btn);
      });
    }

    qvAdd.addEventListener('click', function () {
      if (!qvSize) { qvHint.textContent = 'Please choose a size first.'; return; }
      var variants = getVariants(qvCard);
      var variant = variants[qvSize];
      if (!variant || !variant.available) { qvHint.textContent = 'That size is unavailable.'; return; }

      lastSize = qvSize;
      bundle.push({
        variantId: variant.id,
        title: qvCard.dataset.title,
        print: qvCard.dataset.print,
        size: qvSize,
        price: parseFloat(variant.price),
        image: qvCard.dataset.image
      });
      overlay.classList.remove('is-open');
       renderPanel();
    });

    qvClose.addEventListener('click', function () { overlay.classList.remove('is-open'); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.classList.remove('is-open'); });

    /* ---------- Panel rendering ---------- */
    function money(n) {
      var currency = root.dataset.currency || 'USD';
      var suffix = (currency && currency !== 'USD') ? (' ' + currency) : '';

      return '$' + n.toFixed(2) + suffix;
    }

    function itemsHTML(discountPct) {
      if (bundle.length === 0) return '<div class="byob-empty">' + emptyText + '</div>';
      return bundle.map(function (b, i) {
        var bg = b.image ? ('background-image:url(' + b.image + ')') : '';
        var priceHtml;

        if (discountPct > 0) {
          var discounted = round2(b.price * (100 - discountPct) / 100);
          var savings = round2(b.price - discounted);
          priceHtml =
          '<span class="byob-bp-original">' + money(b.price) + '</span>' +
          '<span class="byob-bp-discounted">' + money(discounted) + '</span>' +
          '<span class="byob-bp-badge">' + discountPct + '% OFF (-' + money(savings) + ')</span>';
        } else {
          priceHtml = money(b.price);
        }

        return '<div class="byob-bitem">' +
          '<div class="byob-bd" style="' + bg + '"></div>' +
          '<div class="byob-bi"><div class="byob-n">' + escapeHtml(b.title) + '</div>' +
          '<div class="byob-s">' + escapeHtml(b.print) + ' · Size ' + escapeHtml(b.size) + '</div></div>' +
          '<div class="byob-bp">' + priceHtml + '</div>' +
          '<button class="byob-rm" data-rm="' + i + '">✕</button></div>';
      }).join('');
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function bindRemove(container) {
      $$('[data-rm]', container).forEach(function (btn) {
        btn.addEventListener('click', function () {
          bundle.splice(parseInt(btn.dataset.rm, 10), 1);
          renderPanel();
        });
      });
    }

    /* ---------- Totals (with discount row) ---------- */

    function renderTotalsRows(totalsSel, rowsSel, n, sub, discountPct, discountAmt, total) {
      var totalsEl = $(totalsSel);
      if (!totalsEl) return;
      totalsEl.style.display = n > 0 ? '' : 'none';

      var rows = '<div class="byob-trow"><span>Subtotal</span><span>' + money(sub) + '</span></div>';

      if (discountAmt > 0) {
        rows += '<div class="byob-trow is-discount">' +
          '<span>Bundle discount (' + discountPct + '%)</span>' +
          '<span>-' + money(discountAmt) + '</span></div>';
      }

      rows += '<div class="byob-trow is-grand"><span>Total</span><span>' + money(total) + '</span></div>';

      setHtml(rowsSel, rows);
    }

    // progress bar update
    function updateLadder(n) {
      var TIER_CONTAINER_INDEXES = [0, 1, 2];  // maps to tier1, tier2, tier3

      $$('[data-byob-ladder]').forEach(function (ladder) {
        var containers = ladder.querySelectorAll('.progress-bar-tier-container');

        TIERS.forEach(function (tier, i) {
          var container = containers[TIER_CONTAINER_INDEXES[i]];
          if (!container) return;

          var hit = n >= tier.qty;
          var tierEl = container.querySelector('.progress-bar-tier');
          if (tierEl) tierEl.classList.toggle('active', hit);
        });
      });
    }

    function refreshCartQty(callback) {
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') + 'cart.js';

      fetch(cartUrl)
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          existingCartQty = cart.item_count || 0;
          if (typeof callback === 'function') callback();
        })
        .catch(function (err) {
          console.error('BYOB: failed to refresh cart qty', err);
        });
    }

    function renderPanel() {
      var n = bundle.length;
      var sub = bundle.reduce(function (a, b) { return a + b.price; }, 0);

      var totalQty = existingCartQty + n;   // <-- combined qty for discount tier logic

      var currentTier = getCurrentTier(totalQty);
      var nextTier = getNextTier(totalQty);
      var discountPct = currentTier ? currentTier.pct : 0;

      var html = itemsHTML(discountPct);

      setHtml('[data-byob-list]', html);
      setHtml('[data-byob-list-mobile]', html);
      bindRemove(root.querySelector('[data-byob-list]'));
      bindRemove(root.querySelector('[data-byob-list-mobile]'));

      var discountAmt = 0;
      if (discountPct > 0) {
        discountAmt = round2(
          bundle.reduce(function (a, b) {
            return a + round2(b.price * discountPct / 100);
          }, 0)
        );
      }
      var total = round2(sub - discountAmt);

      renderTotalsRows('[data-byob-totals]', '[data-byob-totals-rows]', n, sub, discountPct, discountAmt, total);
      renderTotalsRows('[data-byob-totals-mobile]', '[data-byob-totals-rows-mobile]', n, sub, discountPct, discountAmt, total);

      [$('[data-byob-cart-btn]'), $('[data-byob-cart-btn-mobile]')].forEach(function (btn) {
        if (!btn) return;
        if (n === 0) { btn.disabled = true; btn.textContent = 'Add Items To Start'; }
        else { btn.disabled = false; btn.textContent = 'Add Bundle To Cart · ' + money(total); }
      });

      setText('[data-byob-mbar-count]', n + ' item' + (n === 1 ? '' : 's'));
      setText('[data-byob-mbar-total]', money(total));

      var mbarMetaText = '';

      if (currentTier && nextTier) {
        mbarMetaText =
          currentTier.pct + '% off · ' +
          (nextTier.qty - totalQty) +
          ' more for ' +
          nextTier.pct + '%';
      } else if (currentTier && !nextTier) {
        mbarMetaText = currentTier.pct + '% off applied';
      } else if (nextTier) {
        mbarMetaText =
          (nextTier.qty - totalQty) +
          ' more for ' +
          nextTier.pct +
          '% off';
      }
      $$('[data-byob-tier-message]').forEach(function (el) {
        el.textContent = mbarMetaText;
      });

      setText('[data-byob-mbar-meta]', mbarMetaText);
      updateLadder(totalQty);   // progress bar update

      var dots = $('[data-byob-mbar-dots]');
      if (dots) {
        dots.innerHTML = '';
        bundle.slice(0, 4).forEach(function (b) {
          var d = document.createElement('div');
          d.className = 'byob-dd';
          if (b.image) d.style.backgroundImage = 'url(' + b.image + ')';
          dots.appendChild(d);
        });
        if (n > 4) {
          var more = document.createElement('span');
          more.className = 'byob-mbmore';
          more.textContent = '+' + (n - 4);
          dots.appendChild(more);
        }
      }
    }

    function setText(sel, val) {
      $$(sel).forEach(function (el) {
        el.textContent = val;
      });
    }
    function setHtml(sel, val) { var el = $(sel); if (el) el.innerHTML = val; }

    /* ---------- Add to cart ---------- */
    function openCartDrawer() {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { updatedCart: true }
        })
      );

      document.body.classList.add('open-cart', 'open-cc');

      var cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('active');
        if (typeof cartDrawer.notesToggle === 'function') cartDrawer.notesToggle();
        if (typeof cartDrawer.removeProductEvent === 'function') cartDrawer.removeProductEvent();
      }

      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart-drawer:open');
      }
    }

    function addBundleToCart() {
      if (bundle.length === 0) return;
      var items = bundle.map(function (b) { return { id: b.variantId, quantity: 1 }; });

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          bundle = [];                       // <-- bundle clear 
          refreshCartQty(renderPanel);       // <-- fresh cart qty  panel reset 
          openCartDrawer();
        })
        .catch(function (err) {
          console.error('BYOB add to cart failed', err);
        });
    }
    var cartBtn = $('[data-byob-cart-btn]');
    var cartBtnMobile = $('[data-byob-cart-btn-mobile]');
    if (cartBtn) cartBtn.addEventListener('click', addBundleToCart);
    if (cartBtnMobile) cartBtnMobile.addEventListener('click', addBundleToCart);

    /* ---------- Mobile sheet ---------- */
    var mbar = $('[data-byob-mbar]');
    var sheet = $('[data-byob-sheet]');
    var backdrop = $('[data-byob-sheet-backdrop]');
    var sheetClose = $('[data-byob-sheet-close]');

    function openSheet() { sheet.classList.add('is-open'); backdrop.classList.add('is-open'); }
    function closeSheet() { sheet.classList.remove('is-open'); backdrop.classList.remove('is-open'); }
    if (mbar) mbar.addEventListener('click', openSheet);
    if (sheetClose) sheetClose.addEventListener('click', closeSheet);
    if (backdrop) backdrop.addEventListener('click', closeSheet);

    /* ---------- Cart sync ---------- */
    document.addEventListener('byob:cart-mutated', function () {
      refreshCartQty(renderPanel);
    });

    window.addEventListener('focus', function () {
      refreshCartQty(renderPanel);
    });

    applyFilter();
    refreshCartQty(renderPanel);
  }
})();